var ExternalActions = require('./ExternalActions');

var APP_ACTIONS_PUSH_COOLDOWN = 400;
var APP_ACTIONS_ATTEMPTED_FEATURE_PUSH = 5000; // should be less than cool down to work

var AppActions =
{
  _appManager: {},
  _navigator: null,
  initialize: function(appManager, nav)
  {
    this._appManager = appManager;
    this._navigator = nav;

    ExternalActions.initialize(this);
  },

  _appActionsCoolDown: false,
  _attemptedFeature: [],
  _attemptedExtras: [],
  requestFeatureName: function(featureName, extras, shouldAnimate, doAfterLoginSuccess, shouldReplace, shouldPopAfterLogin)
  {
    if( this._appActionsCoolDown ) return;
    if( typeof shouldAnimate === 'undefined' ) shouldAnimate = true;
    if( typeof shouldReplace === 'undefined' ) shouldReplace = false;
    if( featureName == "Rewards" )
    {
      var rewardsCampaignsFeature = this._appManager.getFeatureForName("RewardsCampaigns");
      if( typeof rewardsCampaignsFeature !== 'undefined' )
      {
        featureName = "RewardsCampaigns";
      }
    }
    if( featureName == "EarnPoints" )
    {
      var rewardsCampaignsFeature = this._appManager.getFeatureForName("RewardsCampaigns");
      if( typeof rewardsCampaignsFeature !== 'undefined' )
      {
        featureName = "RewardsCampaigns";
        if( typeof extras === 'undefined' || extras == null ) extras = {};
        extras.showEarnPointsFirst = true;
      }
    }
    if( featureName == "CheckIn" )
    {
      var earnPayFeature = this._appManager.getFeatureForName("EarnPay");
      if( typeof earnPayFeature !== 'undefined' )
      {
        featureName = "EarnPay";
        if( typeof extras === 'undefined' || extras == null ) extras = {};
        extras.showCheckInFirst = true;
      }
    }
    if( featureName == "UseCredit" )
    {
      var earnPayFeature = this._appManager.getFeatureForName("EarnPay");
      if( typeof earnPayFeature !== 'undefined' )
      {
        featureName = "EarnPay";
        if( typeof extras === 'undefined' || extras == null ) extras = {};
        extras.showUseCreditFirst = true;
      }
    }
    // this._attemptedFeature = [];
    // this._attemptedExtras = [];

    var appManager = this._appManager;
    var nav = this._navigator;

    // check for overrides, like if a feature is a subtab of a bigger feature
    if( typeof extras === 'undefined' || extras == null ) extras = {};
    var {featureName, extras} = appManager.getFeatureOverrideForName(featureName, extras);

    var feature = JSON.parse(JSON.stringify(appManager.getFeatureForName(featureName)));
    // if( typeof feature === 'undefined' ) return;

    var needsLogin = feature.data.requiresLogin;
    var prerequisiteFeature = appManager.getPrerequisiteFeatureForName(featureName);
    this._doAfterLoginSuccess = typeof doAfterLoginSuccess !== 'undefined' ? doAfterLoginSuccess : null;
    this._shouldPopAfterLogin = typeof shouldPopAfterLogin !== 'undefined' ? shouldPopAfterLogin : true;
    if( needsLogin && !appManager.isLoggedIn() )
    {
      var loginFeature = appManager.getFeatureForName("Login");
      nav.pushFeature(loginFeature, {}, shouldAnimate);
      this._attemptedFeature.push(feature);
      this._attemptedExtras.push(extras);

      this._appActionsCoolDown = true;
      setTimeout(function()
      {
        AppActions._appActionsCoolDown = false;
      }, APP_ACTIONS_PUSH_COOLDOWN)
    }
    else if( prerequisiteFeature != null )
    {
      this._attemptedFeature.push(feature);
      this._attemptedExtras.push(extras);
      var prerequisiteFeatureName = prerequisiteFeature.data.name;
      this.requestFeatureName(prerequisiteFeatureName, extras, shouldAnimate, doAfterLoginSuccess, shouldReplace);

      // prerequisiteFeature = JSON.parse(JSON.stringify(prerequisiteFeature)); // make a copy to make sure doubles in stack work
      // if( shouldReplace ) nav.setCurrentFeature(prerequisiteFeature);
      // else nav.pushFeature(prerequisiteFeature, {}, shouldAnimate);
    }
    else
    {
      if( shouldReplace ) nav.setCurrentFeature(feature, extras);
      else nav.pushFeature(feature, extras, shouldAnimate);

      this._appActionsCoolDown = true;
      setTimeout(function()
      {
        AppActions._appActionsCoolDown = false;
      }, APP_ACTIONS_PUSH_COOLDOWN)
    }
  },

  featureForData : function(feature, layout, appManager, extras)
  {
    if( this._navigator == null ) return null;
    
    return this._navigator.featureForData(feature, layout, appManager, extras)
  },

  requestPop: function(shouldPushAttemptedFeature)
  {
    var willPushAttemptedFeature = typeof shouldPushAttemptedFeature !== 'undefined' && shouldPushAttemptedFeature && this._attemptedFeature != null && this._attemptedFeature.length > 0;
    var willAttemptFunction = typeof shouldPushAttemptedFeature !== 'undefined' && shouldPushAttemptedFeature && this._doAfterLoginSuccess != null;
    var attemptedFeature = this._attemptedFeature.pop();
    var attemptedFeatureExtras = this._attemptedExtras.pop();
    var appManager = this._appManager;
    var doAfterLoginSuccess = this._doAfterLoginSuccess;

    if( willAttemptFunction )
    {
      if( appManager.isLoggedIn() )
      {
        if( this._shouldPopAfterLogin ) this._navigator.popFeature()
        doAfterLoginSuccess();
      }
      else
      {
        this._attemptedFeature = [];
        this._attemptedExtras = [];
        this._navigator.popFeature()
      }
    }
    else if( willPushAttemptedFeature )
    {
      var needsLogin = attemptedFeature.data.requiresLogin;
      if( !needsLogin || appManager.isLoggedIn() )
      {
        this._navigator.setCurrentFeature(attemptedFeature, attemptedFeatureExtras);
      }
      else
      {
        this._attemptedFeature = [];
        this._attemptedExtras = [];
        this._navigator.popFeature()
      }
    }
    else
    {
      this._attemptedFeature = [];
      this._attemptedExtras = [];
      this._navigator.popFeature();
    }
  },

  requestPopToIndex: function(index)
  {
    this._attemptedFeature = [];
    this._attemptedExtras = [];
    this._navigator.popToIndex(index);
  },

  checkErrorCodeAndReturnIfHandled: function(errorCode)
  {
    if( errorCode !== -21 ) return false;

    var thisThing = this;

    if ( this._appManager.isLoggedIn() )
    {
      this._appManager.logout(function()
      {
        thisThing.requestPopToIndex(0);
        thisThing.showLocalizedAlert("PASSWORD_CHANGED_ALERT_TITLE", "PASSWORD_CHANGED_ALERT_BODY", ["OK_ALERT_BUTTON"]);
      });
    }

    return true;
  },

  setSpinnerShown: function(spinnerShown, spinnerText)
  {
    var spinnerTextTrue = typeof spinnerText !== 'undefined' ? spinnerText : "";
    this._navigator.setState({shouldShowSpinner: spinnerShown, spinnerText: spinnerTextTrue})
  },

  showAlert: function(title, body, buttonTitles, buttonActions, didCancel, hideFrame, disableBackgroundSelectionDismiss, titleFontSize, bodyFontSize, buttonFontSize)
  {
    this._navigator.showAlert(title, body, buttonTitles, buttonActions, didCancel, hideFrame, disableBackgroundSelectionDismiss, titleFontSize, bodyFontSize, buttonFontSize);
  },

  showLocalizedAlert: function(LOC_TITLE, LOC_BODY, LOC_BUTTON_TITLES, buttonActions, didCancel, hideFrame, disableBackgroundSelectionDismiss, titleFontSize, bodyFontSize, buttonFontSize)
  {
    var locManager = this._appManager.getLocalizationManager();
    var title = locManager.localizedStringForKey(LOC_TITLE);
    var body = locManager.localizedStringForKey(LOC_BODY);
    var buttonTitles = [];
    for(var i = 0; i < LOC_BUTTON_TITLES.length; i++)
    {
      var LOC_KEY = LOC_BUTTON_TITLES[i];
      var buttonTitle = locManager.localizedStringForKey(LOC_KEY);
      buttonTitles.push(buttonTitle);
    }
    return AppActions.showAlert(title, body, buttonTitles, buttonActions, didCancel, hideFrame, disableBackgroundSelectionDismiss, titleFontSize, bodyFontSize, buttonFontSize);
  },

  showNetworkErrorAlert: function(okAction, didCancel)
  {
    this._navigator.showNetworkErrorAlert(okAction, didCancel);
  },

  hideAlert: function()
  {
    AppActions._navigator.hideAlert()
  },

  setCustomAlertShown: function(alertShown, alertChildren, didCancel, hideFrame, disableBackgroundSelectionDismiss)
  {
    if(alertShown) this._navigator.showCustomAlert(alertChildren, didCancel, hideFrame, disableBackgroundSelectionDismiss);
    else this._navigator.hideAlert();
  },

  _drawer : null,
  setDrawer: function(drawer)
  {
    this._drawer = drawer;
  },

  closeDrawer: function()
  {
    if( this._drawer != null ) this._drawer.close();
  },

  openDrawer: function()
  {
    if( this._drawer != null ) this._drawer.open();
  },

  toggleDrawer: function()
  {
    if( this._drawer != null ) this._drawer.toggle();
  },

  drawerDidOpen: function()
  {
    if( typeof this._navigator !== 'undefined' )
    {
      var nav = this._navigator;
      setTimeout(function()
      {
        if( !nav._menuExpanded )
        {
          nav._menuExpanded = true;
          nav.forceUpdate();
        }
      }, 50)
    }
  },

  drawerDidClose: function()
  {
    if( typeof this._navigator !== 'undefined' )
    {
      var nav = this._navigator;
      setTimeout(function()
      {
        if( nav._menuExpanded && nav.stackIndex() <= 0 )
        {
          nav._menuExpanded = false;
          nav.forceUpdate();
        }
        else
        {
          nav._menuExpanded = false;
        }
      }, 50)
    }
  }
}

module.exports = AppActions;
